(() => {
  const launcher = document.querySelector('[data-bt-channel-launcher]');
  if (!(launcher instanceof HTMLButtonElement)) return;

  const badge = launcher.querySelector('[data-bt-channel-badge]');
  let attempts = 0;
  let activated = false;

  const updateBadge = (unread = 0, alert) => {
    if (!(badge instanceof HTMLElement)) return;
    const count = Math.max(Number(unread) || 0, Number(alert) || 0);
    badge.hidden = !count;
    badge.textContent = count > 99 ? '99+' : String(Math.max(0, count || 0));
  };

  const activate = () => {
    if (activated || typeof window.ChannelIO !== 'function') return false;
    activated = true;

    window.ChannelIO('hideChannelButton');
    window.ChannelIO('onBadgeChanged', updateBadge);
    window.ChannelIO('onShowMessenger', () => launcher.classList.add('is-messenger-open'));
    window.ChannelIO('onHideMessenger', () => launcher.classList.remove('is-messenger-open'));

    launcher.addEventListener('click', () => window.ChannelIO('showMessenger'));
    launcher.hidden = false;
    return true;
  };

  if (activate()) return;

  const timer = window.setInterval(() => {
    attempts += 1;
    if (activate() || attempts >= 80) window.clearInterval(timer);
  }, 250);
})();
